import { Variables } from 'react-relay';
import { MockResponseConfig } from '../getMockResponse';
import { mockFullLoggedOutUser } from './mockFullLoggedOutUser';

export const mockFullLoggedOutUserOneGroup: MockResponseConfig = {
  ...mockFullLoggedOutUser,
  UnifiedProfileQuery: (variables: Variables) => ({
    data: {
      unified: {
        unifiedProfile: {
          ...mockFullLoggedOutUser.UnifiedProfileQuery(variables).data.unified
            .unifiedProfile,
          username: 'loggedoutonegroup',
        },
      },
    },
  }),
  UnifiedForumsGroupsQuery: (variables: Variables) => ({
    data: {
      unified: {
        unifiedProfile: {
          __typename: 'UnifiedProfile',
          id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889',
          forums: {
            __typename: 'UnifiedForums',
            id: 'ari:cloud:unified-portable-profile::forums/723',
            groups: {
              __typename: 'UnifiedForumsGroupsConnection',
              edges: [
                {
                  cursor: '0',
                  node: {
                    viewHref: '/t5/Welcome-Center/gh-p/WelcomeCenter',
                    title: 'Welcome Center',
                    groupMemberCount: 11,
                    aaid: '62587f99fdb60b0069294184',
                    topicsCount: 6,
                    hasHiddenAncestor: false,
                    joinDate: '2022-06-23T16:50:44Z',
                    membershipType: 'open',
                    avatar: {
                      mediumHref: '',
                    },
                    id: 'ari:cloud:unified-portable-profile::forums/723/groups/grouphub:WelcomeCenter',
                  },
                },
              ],
              totalCount: 1,
            },
          },
        },
      },
    },
  }),
};
